import { store } from "@/store";
import { GetServerSidePropsContext, GetServerSidePropsResult } from "next";
import Image from "next/image";
import Link from "next/link";
// import SocialLinkIcon from "../../comp/SocialLinkIcon";
import { fetchSingleService } from "@/store/slices/service";
import { ImageType, Service } from "@/types/model.types";

import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
type ServiceDetailProps = {
  service: Service;
};

export default function ServiceDetail({ service }: ServiceDetailProps) {
  return (
    <section id="section-content" aria-label="section">
      <div className="container">
        <div className="row gx-5 service-top">
          <div className="col-lg-8">
            <LightGallery
              elementClassNames="lightbox-custom-wrapper"
              onInit={() => {}}
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
            >
              {service.images &&
                service.images.map((image: ImageType) => {
                  return (
                    <a
                      key={image.id}
                      href={`${process.env.NEXT_PUBLIC_DO_CDN}/${image.image}`}
                    >
                      <div key={image.image} className="de-post-type-1">
                        <div className="d-image">
                          <Image
                            width={835}
                            height={417}
                            alt={service.title}
                            src={`${process.env.NEXT_PUBLIC_DO_CDN}/${image.image}`}
                            className="lazy"
                          />
                        </div>
                      </div>
                    </a>
                  );
                })}
            </LightGallery>
          </div>

          <div className="col-lg-4">
            <div className="widget widget_tags">
              <h4>Service Info</h4>
              <div className="small-border"></div>
              <ul>
                {service.keywords?.map((keyword: string) => {
                  return (
                    <li key={keyword}>
                      <a href="#link">#{keyword}</a>
                    </li>
                  );
                })}
              </ul>
              {/* <div className="service-detail-icon">
                <SocialLinkIcon />
              </div> */}
            </div>

            <div className="d-content">
              <h3>
                <a href="#">{service.title}</a>
              </h3>

              {/* <p>
                {service.description
                  ? service.description.replace(/(?:\r\n|\r|\n)/g, '<br>')
                  : '....'}
              </p> */}
              <p>
                {service?.description &&
                  service?.description.split("\n").map((item, idx) => {
                    return (
                      <span key={idx}>
                        {item}
                        <br />
                      </span>
                    );
                  })}
              </p>
              <Link href={"/reservations"} className="btn-main">
                Request a Quote
              </Link>
            </div>
          </div>
        </div>

        {false && (
          <div className="row">
            <div className="col-lg-4 mb20">
              <div className="bloglist s2 item">
                <div className="post-content">
                  <div className="post-image-services">
                    <Image
                      width={405}
                      height={270}
                      alt=""
                      src="/images/news/pic-blog-1.jpg"
                      className="lazy"
                    />
                  </div>
                  <div className="post-text">
                    <h4>
                      <a href="/service-detail">
                        Enjoy Best Travel Experience<span></span>
                      </a>
                    </h4>
                    <p>
                      Dolore officia sint incididunt non excepteur ea mollit
                      commodo ut enim reprehenderit cupidatat labore ad laborum
                      consectetur.
                    </p>
                    <Link
                      className="btn-main"
                      href={{
                        pathname: "/services/[slug]",
                        query: { slug: "xyz" },
                      }}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 mb20">
              <div className="bloglist s2 item">
                <div className="post-content">
                  <div className="post-image-services">
                    <Image
                      width={405}
                      height={270}
                      alt=""
                      src="/images/news/pic-blog-1.jpg"
                      className="lazy"
                    />
                  </div>
                  <div className="post-text">
                    <h4>
                      <a href="/service-detail">
                        Enjoy Best Travel Experience<span></span>
                      </a>
                    </h4>
                    <p>
                      Dolore officia sint incididunt non excepteur ea mollit
                      commodo ut enim reprehenderit cupidatat labore ad laborum
                      consectetur.
                    </p>
                    <Link
                      className="btn-main"
                      href={{
                        pathname: "/services/[slug]",
                        query: { slug: "xyz" },
                      }}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="spacer-single"></div>
      </div>
    </section>
  );
}

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<any>> {
  const {
    query: { slug },
  } = context;
  const service = await store.dispatch(fetchSingleService(slug as String));
  return {
    props: {
      service: service.payload?.data,
    },
  };
}
